<div class="device-payment">
  <!-- Header -->
  <div class="section-header">
    <mat-icon class="section-icon">payment</mat-icon>
    <div>
      <h2 class="section-title">Complete Your Payment</h2>
      <p class="section-subtitle">
        Secure payment via credit card or bank account
      </p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Payment Summary -->
  <div class="payment-summary">
    <h3>Order Summary</h3>
    <div class="summary-items">
      <div *ngFor="let item of cart.items" class="summary-item">
        <span class="item-desc">
          {{ item.quantity }}x {{ item.deviceType | titlecase }}
          <span *ngIf="item.isFirstDevice" class="sale-badge">Sale Price</span>
        </span>
        <span class="item-price">${{ formatPrice(item.quantity * item.unitPrice) }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="summary-totals">
      <div class="total-row">
        <span>Device(s) Subtotal:</span>
        <span>${{ formatPrice(cart.deviceSubtotal) }}</span>
      </div>
      <div *ngIf="cart.taxAmount > 0" class="total-row">
        <span>Sales Tax:</span>
        <span>${{ formatPrice(cart.taxAmount) }}</span>
      </div>
      <div class="total-row">
        <span>Setup Fee (1 visit):</span>
        <span>${{ formatPrice(cart.setupFee) }}</span>
      </div>
      <div *ngIf="cart.simFees > 0" class="total-row">
        <span>SIM Card(s) - First Month:</span>
        <span>${{ formatPrice(cart.simFees) }}</span>
      </div>
      <div class="total-row grand-total">
        <strong>Total Charge TODAY:</strong>
        <strong>${{ formatPrice(cart.totalToday) }}</strong>
      </div>
      <div *ngIf="cart.paymentPlan === '12months'" class="plan-info-row">
        <span><em>Then {{ formatPrice(cart.monthlyInstallment) }}/month for 12 months</em></span>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- What You're Authorizing -->
  <div class="authorization-info">
    <div class="info-box">
      <strong *ngIf="cart.paymentPlan === 'now'">✓ Today's Charge: ${{ formatPrice(cart.totalToday) }}</strong>
      <strong *ngIf="cart.paymentPlan === '12months'">✓ Today: ${{ formatPrice(cart.totalToday) }} + ${{ formatPrice(cart.monthlyInstallment) }}/month for 12 months</strong>
      <p>Your bank account will be authorized immediately when you complete this order.</p>
    </div>
    <div class="info-box">
      <strong>✓ Usage-Based Billing</strong>
      <p>You'll only be charged for overage usage beyond free tier limits:</p>
      <ul>
        <li>Donations: First 200/month free, then $0.10 each</li>
        <li>Emails: First 200/month free, then $0.005 each</li>
      </ul>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Payment Method Section -->
  <div class="payment-method-section">
    <h3>Payment Method</h3>
    <div class="method-info">
      <mat-icon>account_balance</mat-icon>
      <div class="method-details">
        <p class="method-title">Bank Account (ACH)</p>
        <p class="method-desc">Direct debit from your checking or savings account</p>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Reuse Payment Checkbox -->
  <div class="reuse-payment-section">
    <mat-checkbox
      [(ngModel)]="useForBilling"
      [disabled]="hasRecurringCharges"
      class="reuse-checkbox">
      <div class="checkbox-content">
        <strong>✓ Use this payment for monthly auto-billing</strong>
        <p class="checkbox-note">
          Recommended: This saves you from entering payment details again. You
          won't be charged this month—only when you exceed free tier limits.
        </p>
        <p class="checkbox-note" *ngIf="hasRecurringCharges" style="color: #999; font-style: italic;">
          (Already set up for recurring charges)
        </p>
      </div>
    </mat-checkbox>
  </div>

  <mat-divider></mat-divider>

  <!-- Action Buttons -->
  <div class="actions">
    <button
      mat-stroked-button
      (click)="goBack()"
      [disabled]="isProcessing"
      class="back-btn"
    >
      <mat-icon>arrow_back</mat-icon>
      <span>Back to Devices</span>
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="processPayment()"
      [disabled]="isProcessing"
      class="pay-btn"
    >
      <mat-spinner
        *ngIf="isProcessing"
        diameter="20"
        class="btn-spinner"
      ></mat-spinner>
      <mat-icon *ngIf="!isProcessing">lock</mat-icon>
      <span *ngIf="!isProcessing">Authorize Payment - ${{ formatPrice(cart.totalToday) }} Today</span>
      <span *ngIf="isProcessing">Processing Payment...</span>
    </button>
  </div>

  <div class="security-note">
    <mat-icon>verified_user</mat-icon>
    <span>Payments secured by Stripe. Your data is encrypted and secure.</span>
  </div>
</div>
